import type { LogStatus } from './types';

/**
 * Whether a log file can be downloaded based on its display status.
 *
 * Downloadable: `available`, `restored`, or absent/undefined (legacy responses
 * that predate the display-status field).
 * Not downloadable: `archived`, `restoring`, `deleted`.
 */
export const isLogFileDownloadable = (status?: LogStatus): boolean =>
  status === undefined || status === 'available' || status === 'restored';
